import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useAnchorEl, useMiaSelector } from '../components/hooks';
import { UserAvatar } from '../components/UserAvatar';
import { authActionCreators, isItOverridden } from '../ducks/auth';
import { getDisplayName } from '../ducks/me/meSelectors';
import { PermissionOverrideUserText } from '../it/permissions/PermissionOverrideUserText';

interface IUserActionAvatarProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatarColor: { backgroundColor: theme.palette.warning.main },
    opacity: { opacity: '1 !important' as any }
  })
);

let UserActionAvatar: React.FunctionComponent<IUserActionAvatarProps> = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const name = useMiaSelector(getDisplayName);
  const isOverridden = useMiaSelector(isItOverridden);

  const [anchorEl, openMenu, closeMenu] = useAnchorEl();

  const handleLogout = React.useCallback(() => {
    dispatch(authActionCreators.logout());
    closeMenu();
  }, []);
  const handleRefreshPermissions = React.useCallback(() => {
    dispatch(authActionCreators.fetchPermissions(true));
    closeMenu();
  }, []);

  return (
    <>
      <IconButton onClick={openMenu}>
        <UserAvatar className={isOverridden ? classes.avatarColor : undefined} name={name} />
      </IconButton>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={closeMenu}>
        {isOverridden && (
          <MenuItem disabled divider dense className={classes.opacity}>
            <ListItemText
              disableTypography
              primary={<Typography variant="subtitle2">Permissions Overridden</Typography>}
              secondary={
                <Typography variant="subtitle2" color="textSecondary">
                  <PermissionOverrideUserText />
                </Typography>
              }
            />
          </MenuItem>
        )}
        <MenuItem onClick={handleRefreshPermissions} divider>
          Refresh Permissions
        </MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

UserActionAvatar = React.memo<IUserActionAvatarProps>(UserActionAvatar);
export { UserActionAvatar };
